import styled from 'styled-components';

export const NextMatchWidgetWrapper = styled.div`

`;

export const BetWrapper = styled.div`
  position: relative;
  top: 46px;
  width: 400px;
  margin: auto;
  ${props => props.theme.mediaQueries.tablet_big_down_team_next_widget}{
     top: 30px;
     width: 95%;
     max-width: 390px;
  };
`;



// WEBPACK FOOTER //
// ./src/containers/NextMatchWidget/styles.js